import React, { useState, useRef } from 'react';
import './Form.scss';
import emailjs from '@emailjs/browser';
import { EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, EMAILJS_PUBLIC_KEY } from '../services/emailjs';

export function Form() {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [subject, setSubject] = useState('');
    const [address, setAddress] = useState('');
    const [service, setService] = useState('');
    const [date, setDate] = useState('');
    const [booking, setBooking] = useState('');
    const [loading, setLoading] = useState(false);
    const formRef = useRef<HTMLFormElement>(null);

    const sendEmail = async () => {
        if (!formRef.current) return;
        
        try {
            setLoading(true);

            console.log('sending:', 
                'from_name: ', name, '\n',
                'from_email: ', email, '\n',
                'phone: ', phoneNumber, '\n',
                'address: ', address, '\n',
                'subject: ', subject, '\n',
                'message: ', message, '\n',
                'booking: ', booking, '\n',
                'service: ', service, '\n',
                'date: ', date
            )
            
            // Prepare template parameters
            const templateParams = {
                to_name: "Ivy League Painting",
                from_name: name,
                from_email: email,
                phone: phoneNumber,
                address: address,
                subject: subject,
                message: message,
                booking: booking === 'yes' ? 'Yes' : 'No',
                service: service,
                date: date || 'Not specified'
            };
            
            // Send email using EmailJS
            const response = await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_TEMPLATE_ID,
                templateParams,
                EMAILJS_PUBLIC_KEY
            );
            
            console.log('Email sent successfully:', response);
            alert('Email Sent Successfully!');
            
            // setName('');
            // setEmail('');
            // setPhoneNumber('');
            // setAddress('');
            // setSubject('');
            // setMessage('');
            // setBooking('');
            // setService('');
            // setDate('');
            
        } catch (error) {
            console.error('There was a problem sending the email:', error);
            alert('There was a problem sending the email. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        console.log('submitting form: ', name, email, phoneNumber, address, subject, message, booking, service, date);
        event.preventDefault();
        await sendEmail();
    };

    return (
        <form className='form p-2 br-25 cardBlue' onSubmit={handleSubmit} ref={formRef}>
            <div className='label-container'>
                <label className="form-label">Name</label>
            </div>
            <input
                type="text"
                placeholder="Name"
                value={name}
                required
                onChange={(e) => setName(e.target.value)}
            />
            <div className='label-container'>
                <label className="form-label">Email</label>
            </div>
            <input
                type="text"
                placeholder="Email"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
            />
            <div className='label-container'>
                <label className="form-label">Phone Number</label>
            </div>
            <input
                placeholder="Phone Number"
                value={phoneNumber}
                required
                onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <div className='label-container'>
                <label className="form-label">Address</label>
            </div>
            <input
                placeholder="Address"
                value={address}
                required
                onChange={(e) => setAddress(e.target.value)}
            />
            <div className='label-container'>
                <label className="form-label">Subject</label>
            </div>
             <input
                type="text"
                placeholder="Subject"
                value={subject}
                required
                onChange={(e) => setSubject(e.target.value)}
            />
             <div className='label-container'>
                <label className="form-label">Do you want to request a booking?</label>
            </div>
            <div className='checkbox'>
                <label className="radio-tile">
                    <input type="radio" name="booking" value="yes" checked={booking === 'yes'} onChange={(e) => setBooking(e.target.value)} />
                    <span className="radio-label">Yes</span>
                </label>
                <label className="radio-tile">
                    <input type="radio" name="booking" value="no" checked={booking === 'no'} onChange={(e) => setBooking(e.target.value)} />
                    <span className="radio-label">No</span>
                </label>
            </div>

            { booking === 'yes' && 
                <div className='row ptb-1' >
                <div className='fullWidth'>
                    <div className='label-container'>
                        <label className="form-label">Service</label>
                    </div>
                    <div className="radio-container">
                        <label>
                            <input type="radio" value="interior painting" checked={service === 'interior painting'} onChange={(e) => setService(e.target.value)} />
                            Interior Painting
                        </label>
                        <label>
                            <input type="radio" value="exterior painting" checked={service === 'exterior painting'} onChange={(e) => setService(e.target.value)} />
                            Exterior Painting
                        </label>
                        <label>
                            <input type="radio" value="kitchen cabinet painting" checked={service === 'kitchen cabinet painting'} onChange={(e) => setService(e.target.value)} />
                            Kitchen Cabinet Painting
                        </label>
                        <label>
                            <input type="radio" value="staining" checked={service === 'staining'} onChange={(e) => setService(e.target.value)} />
                            Staining
                        </label>
                    </div>
                </div>
                <div className='pl-5'>
                    <div className='label-container'>
                        <label className="form-label">Preferred Date</label>
                    </div>
                    <input
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        min={new Date().toISOString().split('T')[0]}
                        required
                        style={{ position: 'relative' }} // Ensure position is relative to place the indicator absolutely
                    />
                </div>
                </div>
            }
            <div className='label-container'>
                <label className="form-label">Message</label>
            </div>
            
            <textarea
                placeholder="Message"
                value={message}
                required
                style={{ height: '100px', resize: 'none' }}
                onChange={(e) => setMessage(e.target.value)}
            />

            <div className='button-container'>
                <button type="submit" className='button white fadedGrey' disabled={loading}>
                    {loading ? 'Sending...' : 'Send Email'}
                </button>
            </div>
        </form>
    );
}
